<template>
  <div class="login">
    <div class="title">货主注册</div>
    <div class="cont">
      <van-form @submit="onSubmit">
        <div class="form-box">
          <van-field
            v-model="name"
            placeholder="请输入用户名"
            clearable
            :rules="[{ required: true, message: '请填写用户名' }]"
          ></van-field>
          <van-field
            v-model="code"
            center
            clearable
            placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button class="c-bule" type="info" @click="getPhoneCode"
                          :disabled="disabled">{{btntxt}}</van-button>
            </template>
          </van-field>
          <van-field
            v-model="password"
            type="password"
            clearable
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          ></van-field>
          <van-field
            v-model="password1"
            type="password"
            clearable
            placeholder="请再次输入密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          ></van-field>
        </div>
        <div class="form-btn">
          <!--<van-button block type="info" native-type="submit">
            下一步
          </van-button>-->
          <van-button block type="info" :to="{ path: '/RegisterInfo' }">
            下一步
          </van-button>
        </div>
      </van-form>
      <div class="cont-tips" @click="toPage('/Login')">登录</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      name:'',
      code:'',
      password:'',
      password1:'',
      pattern: /\d{11}/,
      btntxt: "获取验证码",
      disabled: false,
      countTime: '' // 倒计时
    };
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getPhoneCode(){
      let that = this
      const { phone } = this.userInfo
      if (phone === '') {
        this.errInfo.phone = '手机号不能为空'
        return false
      }else if (/\d{11}/.test(phone) === false) {
        this.errInfo.phone = '手机号格式不正确'
        return false
      }
      that._countDown(60)
      this.disabled = true;
      const { data: res } = getCode({
        phone
      })
      if(res.code == '0'){
        that.$toast(res.data.desc)
        if(res.data.state != '1'){
          this.disabled = false;
        }
      }else {
        this.disabled = false;
      }
    },
    //倒计时
    _countDown(time) {
      let interval = null
      this.countTime = this._handleTime(time)
      interval = setInterval(() => {
        time -= 1
        this.countTime = this._handleTime(time)
        if (time <= 0) {
          this.countTime = null
          this.btntxt = "重新获取验证码";
          this.disabled = false;
          window.clearInterval(interval)
        }else {
          this.disabled = true;
          this.btntxt = time + "s后重新获取";
        }
      }, 1000)
      this.$once('hook:beforeDestroy', () => {
        window.clearInterval(interval)
      })
    },
    //倒计时显示
    _handleTime(val) {
      val = val < 10 && val >= 0 ? '0' + val : val
      return val
    },
    onSubmit(values) {
      console.log('submit', values);
    }
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/login.less';
</style>



// WEBPACK FOOTER //
// src/pages/Login/Register.vue